import { ChevronLeft } from "@clockwise/icons";
import React, { useEffect, useRef } from "react";

export const SliderHeader = ({
  isSliderOpen,
  onGoBack,
  eventName,
}: {
  isSliderOpen: boolean;
  onGoBack: () => void;
  eventName: string;
}) => {
  const backRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    // Focuses on the new slider content when the active (for accesiibility)
    if (isSliderOpen) {
      setTimeout(() => {
        if (backRef.current) {
          backRef.current.focus();
        }
      }, 100);
    }
  }, [isSliderOpen]);

  return (
    <div className="cw-pr-3 cw-z-30 cw-bg-neutral cw-sticky cw-top-0 cw-pl-2 cw-rounded-t-lg cw-py-3 cw-flex cw-border-b cw-border-solid cw-border-subtle cw-items-center cw-justify-between">
      <button
        aria-label="View event details"
        ref={backRef}
        onClick={onGoBack}
        className="cw-flex cw-outline-positive-emphasis cw-bg-neutral cw-border-none cw-rounded-lg cw-p-1 cw-items-center cw-text-subtle hover:cw-text-subtle-hover cw-cursor-pointer hover:cw-bg-neutral-hover"
      >
        <ChevronLeft className="cw-w-4 cw-h-4 cw-mt-[1px]" />
        {eventName}
      </button>
    </div>
  );
};
